if (!process.env.REACT_APP_ENV || process.env.REACT_APP_ENV === 'dev') {
  module.exports = require('./configure.store.dev')
} else {
  module.exports = require('./configure.store.prod')
}
